module.exports = __webpack_public_path__ + "static/fonts/SFProDisplay-Bold.42d79eb.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/SFProDisplay-Bold/SFProDisplay-Bold.ttf
// module id = zXMn
// module chunks = 16